import { isAxiosError } from 'axios'
import { toast } from '@/hooks/use-toast'

export function getErrorMessage(e: unknown): string {
  if (isAxiosError(e)) return e.response?.data?.message ?? e.message
  return e instanceof Error ? e.message : 'Unknown error'
}

/** Mutation callbacks that show toast on success/error. Use with mutation.mutate(vars, toastCallbacks(...)) */
export function toastCallbacks(opts: {
  onSuccess?: string
  onError?: string
  onSuccessFn?: () => void
}) {
  return {
    onSuccess: () => {
      if (opts.onSuccess) toast({ title: opts.onSuccess })
      opts.onSuccessFn?.()
    },
    onError: (e: unknown) =>
      toast({ title: opts.onError ?? 'Failed', description: getErrorMessage(e), variant: 'destructive' }),
  }
}
